import _ from "lodash";

export default function initItem(item, config) {
  if (!item || !config) return item;

  const result = _.cloneDeep(item);

  const extractValue = (path, data) => {
    return path
      .split(".")
      .reduce((acc, curr) => (acc ? acc[curr] : undefined), data);
  };

  const extractLabel = (data, labelFields) => {
    return labelFields
      .map((fieldPath) => extractValue(fieldPath, data))
      .filter(Boolean)
      .join(" - ");
  };

  const processPath = (data, segments, configEntry) => {
    const [currentSegment, ...restSegments] = segments;

    if (!currentSegment) return;

    const target = _.get(data, currentSegment);

    if (Array.isArray(target)) {
      // پردازش آرایه‌ها
      _.set(
        data,
        currentSegment,
        target.map((item) => {
          if (restSegments.length > 0) {
            // پردازش ادامه مسیر
            processPath(item, restSegments, configEntry);
            return item;
          } else {
            // پردازش آخرین سطح برای عناصر آرایه
            return {
              value: extractValue(configEntry.valueField, item) ?? null,
              label: extractLabel(item, configEntry.labelFields) ?? null,
            };
          }
        })
      );
    } else if (restSegments.length > 0 && typeof target === "object") {
      // پردازش مسیرهای باقی‌مانده برای اشیاء
      processPath(target, restSegments, configEntry);
    } else if (target && typeof target === "object") {
      // پردازش آخرین سطح برای اشیاء
      _.set(data, currentSegment, {
        value: extractValue(configEntry.valueField, target) ?? null,
        label: extractLabel(target, configEntry.labelFields) ?? null,
      });
    }
  };

  Object.keys(config).forEach((key) => {
    const segments = key.split(".");
    processPath(result, segments, config[key]);
  });

  return result;
}
